<script>
const formatUnitText = function(unit) {
  return unit === '%' ? '%' : '元'
}
const calculateValue = function(number, unit, total) {
  return `${unit === '%' ? convertPercentToValue(number, total) : number}`
}
const convertPercentToValue = function(percentage, total) {
  return Math.round((total * percentage) / 100) || 0
}

export default {
  filters: {
    formatUnitText,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      required: true,
    },
    prepaidOrder: {
      type: Object,
      default: () => {},
    },
    paidMode: {
      type: Boolean,
      default: false,
    },
    isNotPayPrepaid: {
      type: Boolean,
      default: false,
    },
    prepaidOrderUuid: {
      type: String,
      default: '',
    },
    // 看總訂單時，這個container的所有資料
    containerAllItem: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  data() {
    return {
      tryingCancel: false,
      prepaidReturnOption: 'noReturn', // 'noReturn' | 'return'，僅 isPaidByPrepaid 時使用
      submitData: {
        note: '',
        refundUnit: '%', // 不會送給後端
        refundNumber: '', // 不會送給後端
      },
    }
  },
  computed: {
    dialogTitle() {
      // 0: 授權成功，剛刷完卡，只可以整筆退款
      // 1: 請款提送中、請款中，都不可以退款
      // 2: 請款完成＋未退款，可以選擇退款比例
      // 3: 拿不到單筆交易紀錄、交易紀錄取得失敗、付款未成功、請款完成＋退款提送中or退款中or退款完成
      const newebpayStatusMap = {
        0: '確定取消此訂單及授權？',
        1: '此筆訂單尚在金流請款中',
        2: '確定取消此筆訂單？',
        3: '取消訂單時產生非預期之錯誤',
      }
      const cancelStatus = this.showViewForDelete ? '刪除' : '取消'

      return this.isPaidStatus ? '將訂單狀態改為已付款' : newebpayStatusMap[this.newebpayStatus] || `確定${cancelStatus}此筆${this.dialogTitleId}${this.dialogTitleOrder}?`
    },
    dialogTitleId() {
      try {
        if (!this.containerAllItem) {
          return this.order.orderNo ? this.order.orderNo : this.order.orderContainerDisplayId
        }
        if (Object.keys(this.containerAllItem).length > 0) {
          return this.containerAllItem['orders'][0].orderContainerDisplayId
        }
        // 看單一母訂單 && 卡單狀態下
        if (Object.keys(this.containerAllItem).length === 0 && !this.isPaidStatus) {
          return ''
        }
        // 看單一訂單 && 卡單狀態下
        if (Object.keys(this.containerAllItem).length === 0 && this.isPaidStatus) {
          return this.order.orderNo ? this.order.orderNo : this.order.orderContainerDisplayId
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    dialogTitleOrder() {
      let text = '訂單'
      if (!this.containerAllItem) {
        return text
      }
      if (Object.keys(this.containerAllItem).length === 0 && !this.isPaidStatus) {
        text = '項目'
      }
      return text
    },
    refundNumberMax() {
      return this.isRefundPercentage ? 100 : this.order.priceTotal
    },
    refundValue() {
      return calculateValue(this.submitData.refundNumber, this.submitData.refundUnit, this.order.priceTotal)
    },
    newebpayStatus() {
      return this.order.newebpayStatus
    },
    isPaidStatus() {
      let status = false
      if (this.prepaidOrder) {
        status = (this.order.status !== 0 && this.prepaidOrder.status === 1) || this.order.paymentStatus === 'PAID' || this.order.status === 1
      } else {
        status = (this.order.status !== 0 && this.order.paymentStatus === 'PAID') || this.order.status === 1
      }
      return status
    },
    isPaidByCreditCard() {
      return this.order.paymentMethod === 'Credit'
    },
    canOnlineRefund() {
      return this.order.refund === 1
    },
    isRefundPercentage() {
      return this.submitData.refundUnit === '%'
    },
    isPrepaidOrder() {
      return this.order.hasOwnProperty('prepaidTitle')
    },
    isPaidByPrepaid() {
      return !!this.order.prepaidOrderUuid
    },
    submitRules() {
      return {
        refundUnit: [
          {
            required: this.canOnlineRefund,
            message: '請選擇退款種類',
            trigger: 'change',
          },
        ],
        refundNumber: [
          {
            required: this.canOnlineRefund,
            message: '請輸入退款金額',
            trigger: 'change',
          },
          {
            type: 'number',
            min: 0,
            max: this.refundNumberMax,
            message: `請輸入小於 ${this.refundNumberMax} 之數字`,
          },
        ],
      }
    },
    /**
     * @description 計算是不是要走刪除
     */
    showViewForDelete() {
      if (this.order.orderContainerIsTemp === 1 && !this.isPrepaidOrder) {
        return true
      }
      return false
    },
  },
  watch: {
    newebpayStatus: {
      handler(value) {
        if (value === 0) this.submitData.refundNumber = 100
      },
      immediate: true,
    },
  },
  methods: {
    handleClose() {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
      this.prepaidReturnOption = 'noReturn'
      this.$emit('update:visible', false)
    },
    emitPaid() {
      this.$emit('paid', this.submitData.note)
      this.handleClose()
    },
    emitCancelled() {
      this.$emit('cancelled')
      this.handleClose()
    },
    emitClose() {
      this.$emit('emitStore')
    },
    async tryToCancel() {
      let CANCEL_API_URL = ''
      let baseData = {
        orderId: this.order.id, // for單一訂單
        cancelData: {
          ...this.submitData,
          refundValue: this.refundValue,
        },
        ids: [this.order.id], // for單一訂單
      }
      if (this.isPrepaidOrder) {
        CANCEL_API_URL = 'prepaid/cancelOrder'
        if (this.isPaidByPrepaid && this.prepaidReturnOption === 'return') {
          baseData.cancelData.returnCredit = 1
        }
      }
      // 單一訂單 -> 非卡單狀態 -> 走正常order/cancel
      if (this.order.orderContainerIsTemp === 0 && !this.isPrepaidOrder && (Object.keys(this.containerAllItem).length === 0 || !this.containerAllItem)) {
        // console.log('單一訂單 -> 非卡單狀態 -> 走正常order/cancel')
        CANCEL_API_URL = 'order/cancel'
        if (this.isPaidByPrepaid && this.prepaidReturnOption === 'return') {
          baseData.cancelData.returnCredit = 1
        }
      }
      // 單一訂單 -> 卡單狀態 -> 走刪除
      if (this.order.orderContainerIsTemp === 1 && !this.isPrepaidOrder && (!this.containerAllItem || Object.keys(this.containerAllItem).length === 0)) {
        // console.log('單一訂單 -> 卡單狀態 -> 走刪除')
        CANCEL_API_URL = 'order/deleteOrderItem'
      }
      // container的取消訂單（針對整個container）
      if (Object.keys(this.containerAllItem).length > 0 && !this.isPrepaidOrder) {
        // console.log('container的取消訂單')
        CANCEL_API_URL = 'order/containerCancel'
        baseData = Object.assign({}, baseData, {
          uuid: this.containerAllItem.uuid,
          merchantNote: baseData.cancelData.note,
        })
      }
      console.log(CANCEL_API_URL, baseData)

      await this.cancelApi(CANCEL_API_URL, baseData)
    },
    async cancelApi(CANCEL_API_URL, baseData) {
      this.tryingCancel = true
      try {
        await this.$store.dispatch(CANCEL_API_URL, baseData)
        const cancelStatusText = this.showViewForDelete ? '刪除' : '取消'
        this.$message({
          message: `${cancelStatusText}成功！`,
          type: 'success',
        })

        // 如果是刪除訂單要做的事情
        if (CANCEL_API_URL === 'order/deleteOrderItem') {
          this.$emit('deleteLocalStorage')
          this.$emit('renewContainerOrders')
        }
        if (this.order.parentId === null) {
          this.emitClose()
        } else {
          this.emitCancelled()
        }
      } catch (error) {
        console.error('TCL: tryToCancel -> error', error)
      } finally {
        this.tryingCancel = false
      }
    },
    handleCancel() {
      if (this.showViewForDelete) {
        this.tryToCancel()
        return
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.tryToCancel()
        }
      })
    },
    goToPrepaidOrder(id) {
      this.$router.push({
        name: 'orders',
        query: {
          type: 'prepaidOrder',
          id,
        },
      })
    },
  },
}
</script>
<template>
  <el-dialog width="550px" :visible="visible" :show-close="false" top="0" append-to-body>
    <h5 slot="title" class="fw-regular" style="margin-bottom: 0; font-size: 20px">
      {{ dialogTitle }}
    </h5>
    <el-form v-if="!showViewForDelete" ref="form" :model="submitData" :rules="submitRules" class="el-form-item--normal-margin">
      <template v-if="isPaidStatus">
        <template v-if="isNotPayPrepaid">
          <p style="margin-top:0;text-align: center;">抵用的{{ $t('prepaid.BASE') }}方案 <span class="alert-text">尚未付款</span>。<br />請問是否要將此筆訂單的狀態修改為【已付款】？</p>
          <el-form-item prop="note" label="">
            <el-input v-model="submitData.note" type="textarea" :rows="2" placeholder="請輸入付款備註"></el-input>
          </el-form-item>
        </template>

        <template v-if="!isNotPayPrepaid">
          <el-form-item prop="note" label="付款備註">
            <el-input v-model="submitData.note" type="textarea" :rows="2" placeholder="請輸入付款備註"></el-input>
          </el-form-item>
        </template>
      </template>

      <template v-if="!isPaidStatus">
        <template v-if="isPaidByCreditCard">
          <el-alert v-if="!canOnlineRefund" title="此訂單非線上付款，請自行處理退款事宜。" type="warning" :closable="false"></el-alert>
          <template v-else>
            <el-alert v-if="newebpayStatus === 0" title="此訂單目前授權成功但尚未正式扣款，僅能整筆退款，無法部分退款。" type="error" :closable="false"></el-alert>
            <el-alert v-if="newebpayStatus === 1" title="此訂單目前金流尚在請款流程中，暫無法取消訂單，請稍後再試。" type="error" :closable="false"></el-alert>
            <el-alert v-if="newebpayStatus === 3" title="產生非預期之錯誤，請通知我們。" type="error" :closable="false"></el-alert>
            <template v-if="newebpayStatus === 2">
              <small>退訂單的 20％，退款種類請選「訂單總金額的百分比（％）」，退款百分比請輸入「20」。</small>
              <br />
              <small>退 150 元，退款種類請選「指定金額」，退款金額請輸入「150」。</small>
              <el-form-item prop="refundUnit" label="退款種類">
                <el-select v-model="submitData.refundUnit">
                  <el-option label="訂單總金額的百分比（％）" value="%"></el-option>
                  <el-option label="指定金額" value="fixed"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="refundNumber" :label="`退款${isRefundPercentage ? '百分比' : '金額'}`">
                <small>訂單金額 {{ order.priceTotal }} 元</small>
                <el-input v-model.number="submitData.refundNumber" min="0" placeholder="請輸入退款金額">
                  <template v-slot:append>{{ submitData.refundUnit | formatUnitText }}</template>
                </el-input>
                <small v-if="isRefundPercentage && submitData.refundNumber >= 0">經四捨五入計算，將會退 {{ refundValue }} 元給客戶</small>
              </el-form-item>
            </template>
          </template>
        </template>
        <el-form-item v-if="newebpayStatus !== 1 || newebpayStatus !== 3" prop="note" class="mb-2">
          <span slot="label" class="text-secondary">取消原因</span>
          <el-input v-model="submitData.note" type="textarea" class="is-round is-border" :rows="5" placeholder="請輸入取消原因"></el-input>
        </el-form-item>
        <span class="text-secondary">僅作取消訂單說明使用；若有退款請另行操作[退款紀錄]</span>
        <el-form-item v-if="isPaidByPrepaid" label="包月次數處理" class="mt-4 mb-0">
          <el-radio-group v-model="prepaidReturnOption">
            <el-radio label="noReturn">不退回包月次數</el-radio>
            <el-radio label="return">退回包月次數</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
    </el-form>
    <span slot="footer" class="dialog-footer d-md-flex gap-2">
      <el-button class="w-100 is-round" @click="handleClose">
        關閉
      </el-button>
      <el-button v-if="isNotPayPrepaid && isPaidStatus" class="w-100 is-round  ml-md-auto ml-0 mt-md-0 mt-2" @click="goToPrepaidOrder(prepaidOrderUuid)">查看{{ $t('prepaid.BASE') }}方案</el-button>
      <el-button v-if="newebpayStatus === 1 || newebpayStatus === 3" class="w-100 is-round  ml-md-auto ml-0 mt-md-0 mt-2" type="primary" @click="handleClose">關閉</el-button>
      <el-button v-else type="primary" class="w-100 is-round ml-md-auto ml-0 mt-md-0 mt-2" :loading="tryingCancel" v-on="{ click: isPaidStatus ? emitPaid : handleCancel }">
        {{ isPaidByPrepaid ? '確認取消' : '確定' }}
      </el-button>
    </span>
  </el-dialog>
</template>
